const categoryCards = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20white%20and%20beige%20sneakers%20arranged%20on%20weathered%20concrete%20steps%20with%20soft%20urban%20sunlight%20streetwear%20fashion%20photography%20minimal%20background%20clean%20editorial%20product%20shot%20warm%20golden%20tones&width=600&height=400&seq=cat-shoes-2026-v3&orientation=landscape',
  },
  {
    name: 'Hoodies & Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20knit%20hoodies%20and%20wool%20sweaters%20neatly%20folded%20on%20rustic%20oak%20wooden%20ladder%20shelf%20soft%20window%20light%20warm%20autumn%20atmosphere%20lifestyle%20fashion%20editorial%20photography&width=600&height=400&seq=cat-hoodies-2026-v3&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20graphic%20t-shirts%20hanging%20on%20industrial%20black%20metal%20clothing%20rack%20against%20exposed%20red%20brick%20wall%20soft%20studio%20lighting%20streetwear%20editorial%20photography%20clean%20modern%20aesthetic&width=600&height=400&seq=cat-tshirts-2026-v3&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20leather%20bomber%20jacket%20draped%20over%20vintage%20mid-century%20armchair%20warm%20amber%20table%20lamp%20glow%20cozy%20evening%20mood%20fashion%20editorial%20photography%20rich%20textured%20interior&width=600&height=400&seq=cat-jackets-2026-v3&orientation=landscape',
  },
  {
    name: 'Pants & Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20denim%20jeans%20and%20casual%20chino%20shorts%20stacked%20on%20elegant%20white%20marble%20countertop%20soft%20morning%20natural%20light%20minimalist%20fashion%20product%20photography%20clean%20aesthetic&width=600&height=400&seq=cat-pants-2026-v3&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20stylish%20baseball%20caps%20and%20beanies%20arranged%20on%20weathered%20barn%20wood%20wall%20hooks%20soft%20diffused%20daylight%20casual%20fashion%20accessories%20lifestyle%20photography%20warm%20earthy%20tones&width=600&height=400&seq=cat-headwear-2026-v3&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20tracksuit%20and%20two-piece%20outfit%20displayed%20on%20minimalist%20white%20mannequin%20torso%20against%20soft%20grey%20studio%20backdrop%20clean%20fashion%20editorial%20photography%20professional%20product%20shot&width=600&height=400&seq=cat-sets-2026-v3&orientation=landscape',
  },
  {
    name: 'Underwear & Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20cotton%20underwear%20basics%20arranged%20on%20crumpled%20natural%20linen%20bed%20sheets%20gentle%20morning%20sunlight%20streaming%20through%20sheer%20curtains%20clean%20wellness%20lifestyle%20photography&width=600&height=400&seq=cat-underwear-2026-v3&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20basketball%20and%20soccer%20jerseys%20hanging%20on%20vintage%20locker%20room%20metal%20hooks%20bright%20overhead%20fluorescent%20light%20athletic%20sports%20fashion%20photography%20dynamic%20energetic%20mood&width=600&height=400&seq=cat-jersey-2026-v3&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20wristwatches%20sunglasses%20and%20minimalist%20jewelry%20arranged%20on%20deep%20forest%20green%20velvet%20display%20tray%20soft%20spotlight%20illumination%20luxury%20accessories%20editorial%20photography%20rich%20sophisticated%20mood&width=600&height=400&seq=cat-accessories-2026-v3&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20leather%20handbags%20and%20canvas%20tote%20bags%20displayed%20on%20antique%20brass%20shelving%20unit%20warm%20ambient%20boutique%20lighting%20fashion%20retail%20editorial%20photography%20elegant%20luxurious%20atmosphere&width=600&height=400&seq=cat-bags-2026-v3&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Woven%20fabric%20belts%20and%20classic%20leather%20straps%20coiled%20on%20antique%20brass%20belt%20rack%20mounted%20on%20pale%20plaster%20wall%20soft%20natural%20window%20light%20menswear%20accessories%20editorial%20photography&width=600&height=400&seq=cat-belts-2026-v3&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crystal%20glass%20perfume%20bottles%20with%20amber%20liquid%20arranged%20on%20vintage%20mirrored%20vanity%20table%20soft%20candlelight%20glow%20romantic%20elegant%20fragrance%20editorial%20photography%20warm%20intimate%20atmosphere&width=600&height=400&seq=cat-perfumes-2026-v3&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20lifestyle%20gadgets%20and%20novelty%20items%20arranged%20on%20speckled%20terrazzo%20desk%20with%20small%20potted%20succulents%20bright%20natural%20daylight%20modern%20creative%20workspace%20product%20photography%20clean%20cheerful%20mood&width=600&height=400&seq=cat-other-2026-v3&orientation=landscape',
  },
];

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          <div className="lg:col-span-1">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full">
              Explore
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight leading-tight">
              Browse All{' '}
              <span className="text-accent-600">Categories</span>
            </h2>
          </div>
          <div className="lg:col-span-2">
            <p className="text-foreground-500 text-base leading-relaxed">
              Discover products across 14 carefully organized categories. From trendy sneakers and cozy hoodies to luxury accessories and fragrances, every category is updated with fresh finds regularly. Click any category to explore on the main Superbuy Sheet platform.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {categoryCards.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`Superbuy Sheet ${cat.name} products`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-md text-xs font-medium text-foreground-700">
                  <span className="w-1.5 h-1.5 inline-block rounded-full bg-accent-500 mr-1.5"></span>
                  {cat.name}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-accent-700 transition-colors">
                  {cat.name}
                </h3>
                <p className="mt-1 text-xs text-foreground-400">
                  Browse {cat.name.toLowerCase()} collection →
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}